import * as React from "react";
import { LeagueLabel } from "../..";
//import { createEmptyLabel } from ".";
export const renderLiveStreamLabel = (hasLiveEvents, text) => {
    return (hasLiveEvents ?
        React.createElement(LeagueLabel, { className: "rj-league-list__live-stream-label", text: text })
        : React.createElement(React.Fragment, null));
};
//# sourceMappingURL=renderLiveStreamLabel.js.map